
import { ReactNode } from 'react';

import { InMemoryMultiSelectList } from '@/components/form-controls';
import { MultiSelectOption } from '@/components/form-controls/multi-select-list';
import { Lookup } from '@/types/lookup';

type ClassificationFilterProps = {
  /**
   * Label to appear above the field, optional.
   */
  label?: string;

  /**
   * Placeholder text, defaults to "Search by Class"
   */
  placeholder?: string;

  /**
   * The list of currently-selected options, required.
   */
  selected: MultiSelectOption[];

  /**
   * Help text to display in a tooltip next to the label, optional.
   */
  help?: ReactNode;

  /**
   * Error message to display when the field is invalid, optional.
   */
  error?: ReactNode;

  /**
   * Whether the field is required, defaults to false.
   */
  required?: boolean;

  /**
   * Whether the field is disabled, defaults to false.
   */
  disabled?: boolean;
  

  /**
   * Event handler for updating the current selection.
   * @param selected the new value of the multi-select
   */
  onSelectionChange: (selected: MultiSelectOption[]) => void;

  /**
   * The list of classifications to choose from, required.
   */
  classifications: Lookup[];

  
  /**
   * Whether to show the selected items inline, defaults to true.
   */
  showSelectedInline?: boolean;

};

/**
 * Lazy-load filter for Classifications.
 */
export const ClassificationFilter = (props: ClassificationFilterProps) => {

  const {
    placeholder = 'Search by Class',
    label,
    help,
    selected,
    required,
    error,
    classifications,
    showSelectedInline,
    onSelectionChange,
  } = props;

  return (
      <InMemoryMultiSelectList
        label={label ?? 'Classes'}
        help={help}
        required={required}
        error={error}
        placeholder={placeholder}
        options={classifications}
        value={selected}
        onChange={onSelectionChange}
        showSelectedInline={showSelectedInline}
      />
    );
};
